import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  CHART_AXIS,
  CHART_COLORS,
  CHART_TOOLTIP_ITEM_STYLE,
  CHART_TOOLTIP_STYLE,
} from './chart-theme';

export interface HistogramBucket {
  label: string;
  n: number;
}

interface HistogramProps {
  data: HistogramBucket[];
  height?: number;
  /** Singular noun (e.g. "post") used in the tooltip. */
  noun?: string;
}

export function Histogram({
  data,
  height = 220,
  noun = 'post',
}: HistogramProps): JSX.Element {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -12 }}>
        <CartesianGrid stroke={CHART_AXIS.stroke} vertical={false} />
        <XAxis
          dataKey="label"
          stroke={CHART_AXIS.stroke}
          tick={CHART_AXIS.tick}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke={CHART_AXIS.stroke}
          tick={CHART_AXIS.tick}
          tickLine={false}
          axisLine={false}
          width={40}
          allowDecimals={false}
        />
        <Tooltip
          contentStyle={CHART_TOOLTIP_STYLE}
          itemStyle={CHART_TOOLTIP_ITEM_STYLE}
          cursor={{ fill: 'rgba(255,255,255,0.04)' }}
          formatter={(v: number) => [
            `${v.toLocaleString()} ${noun}${v === 1 ? '' : 's'}`,
            'Count',
          ]}
        />
        <Bar
          dataKey="n"
          radius={[4, 4, 0, 0]}
          maxBarSize={48}
          isAnimationActive={false}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={CHART_COLORS[0]} fillOpacity={0.85 - i * 0.07} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
